import React, { useState } from "react";
import { AdvancingTemplateState, type TemplateFormGroup } from "./model";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { routes } from "utilities/routing/generatedRoutes";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { TemplateEditForm, getDefaultFormGroups, getTemplateRows } from "./components/TemplateEditForm";
import { useClientId } from "common/SessionContext";

interface AdvancingTemplateNewSectionProps {
  formGroups: TemplateFormGroup[]
}

export const AdvancingTemplateNewSection = (props: AdvancingTemplateNewSectionProps) => {
  const clientId = useClientId();
  const [advancingTemplate, setAdvancingTemplate] = useState<AdvancingTemplateState>({
    name: "",
    formGroups: getDefaultFormGroups(props.formGroups)
  })

  const submit = () => {
    return window.CoreApi.AdvancingTemplate.Create({
      clientId,
      name: advancingTemplate.name,
      rows: getTemplateRows(advancingTemplate.formGroups)
    })
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.advancingTemplate_List().absolute}
    sections={[{
      key: "advancingTemplate",
      type: "regular",
      title: RESX.Advancing.AdvancingTemplate,
      fields: [{
        key: "name",
        hideLabel: true,
        label: RESX.GeneralLabels.Name,
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}><RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.advancingTemplate.maxNameLength}
            value={advancingTemplate.name}
            onChange={(name) => { setAdvancingTemplate({ ...advancingTemplate, name }); }}
          />
        </div>
      }, {
        key: "formSections",
        hideLabel: true,
        label: "",
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}>
          <TemplateEditForm
            formGroups={advancingTemplate.formGroups}
            onChange={formGroups => setAdvancingTemplate({ ...advancingTemplate, formGroups })}
          />
        </div>
      }]
    }]}
  />
}